import React from 'react';
import Form from '../../../components/Form';
import Title from '../../../components/Title';
import Dropzone from '../../../components/DropzoneJS';

function Images() {
  return (
    <>
      <Form>
        <Title variant="h5" component="h2">Carga masiva de imágenes</Title>
        <Dropzone uri="/service/v1/upload_img" />
      </Form>
    </>
  );
}

export default Images;
